// ANGULAR IMPORT
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppRoutes } from './app.routes';
import { AgmConfig } from './app.config';
import { AgmCoreModule } from '@agm/core';

// APP IMPORT
import { AppComponent } from './app.component';
import { HomeComponent } from './pages/home/home.component';
import { Page404Component } from './pages/404/404.component';
import { ContactComponent } from './pages/contact/contact.component';
import { ConsulterComponent } from './pages/consulter/consulter.component';
import { SeancesComponent } from './pages/seances/seances.component';
import { AproposComponent } from './pages/apropos/apropos.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { SeparatorComponent } from './components/separator/separator.component';
import { OffersComponent } from './components/offers/offers.component';
import { PresentationComponent } from './components/presentation/presentation.component';
import { CreatorComponent } from './components/creator/creator.component';
import { SymptomesComponent } from './components/symptomes/symptomes.component';


@NgModule({
  declarations: [
    AppComponent,
    Page404Component,
    ConsulterComponent,
    ContactComponent,
    HomeComponent,
    SeancesComponent,
    AproposComponent,
    HeaderComponent,
    FooterComponent,
    SeparatorComponent,
    SeparatorComponent,
    OffersComponent,
    PresentationComponent,
    CreatorComponent,
    SymptomesComponent
  ],
  imports: [
    BrowserModule,
    AgmCoreModule.forRoot(AgmConfig),
    RouterModule.forRoot(AppRoutes),
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/enzo/Desktop/capsycofr-angular/src/app/app.module.ts